/**
 * Labstep
 *
 * @module components/User/Settings/Email
 * @desc Email
 */

import type React from 'react';
import type { IUserSettingsEmailProps } from './types';

export const UserSettingsEmail: React.FC<IUserSettingsEmailProps> = ({
  user,
}) => (
  <div>
    <div>
      <span>Email</span>
    </div>
    <p>{user.username}</p>
  </div>
);
